import React from 'react';
import CustomTooltip from '../common/tooltip/CustomTooltip';

export interface DropdownItemData<T> {
  name: string;
  type: T;
}

interface DropdownItemProps {
  name: string;
  className?: string;
  icon?: string;
  tooltipRef?: string;
  tooltipText?: string;
  tooltipLink?: string;
  isDisabled?: boolean;
  isNew?: boolean;
}

const DropdownItem: React.FC<DropdownItemProps> = ({
  name,
  className,
  icon,
  tooltipRef,
  tooltipText,
  tooltipLink,
  isDisabled,
  isNew,
}) => {
  return (
    <>
      <div
        className={`dropdown-item ${className || ''}`}
        id={tooltipRef ? `indicator-${tooltipRef}` : ''}
      >
        {icon && <div className={`dropdown-item__icon ico--xs ${icon}`} />}
        <div className={`p-dropdown-item ${isDisabled ? 'p-dropdown-item--disabled' : ''}`}>{name}</div>
        {isNew && <span className="indicator indicator--new">New</span>}
      </div>
      {tooltipText && tooltipRef && (
        <CustomTooltip tooltipText={tooltipText} targetRef={`indicator-${tooltipRef}`} link={tooltipLink} />
      )}
    </>
  );
};

export default DropdownItem;
